// requireAuth.js
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";

export default function (ComposedComponent) {

    class Authenticate extends React.Component {

        render() {

            // Niet ingelogd → terug naar login
            if (!this.props.authUser) {
                return <Redirect to="/login" />;
            }

            // Ingelogd → component renderen
            return <ComposedComponent {...this.props} />;
        }
    }

    function mapStateToProps(state) {
        return {
            authUser: state.auth.authUser // ⭐ auth-user uit JWT
            // mendixUser wordt elders opgehaald
        };
    }

    return connect(mapStateToProps)(Authenticate);
}
